import React from 'react'

export default function IibAndIfa() {
  return (
    <div style={{color:"white"}}>IibAndIfa</div>
  )
}
